// Standardudstyr-felter vist i en separat boks på CarDetail.
// Disse felter må IKKE indgå i den øverste MissingFieldsBox-oversigt.

export type EquipmentScope = 'variant' | 'specs';
export type EquipmentFieldType = 'boolean' | 'number';

export interface EquipmentFieldDef {
  key: string;
  label: string;
  scope: EquipmentScope;
  /** Vis kun for elbiler (powertrain_type === 'EV'). */
  evOnly?: boolean;
  /** Standard er 'boolean' (Ja/Nej). Brug 'number' for tællefelter som Isofix-antal. */
  type?: EquipmentFieldType;
  unit?: string;
}

export const EQUIPMENT_FIELDS: EquipmentFieldDef[] = [
  { key: 'heat_pump_standard', label: 'Varmepumpe', scope: 'variant', evOnly: true },
  { key: 'batteriforvarmning', label: 'Batteriforvarmning', scope: 'specs', evOnly: true },
  { key: 'adaptive_cruise_control', label: 'Adaptiv fartpilot', scope: 'variant' },
  { key: 'lane_assist', label: 'Vognbaneassistent', scope: 'variant' },
  { key: 'blind_spot_assist', label: 'Blindvinkelassistent', scope: 'variant' },
  { key: 'auto_emergency_brake', label: 'Automatisk nødbremse', scope: 'variant' },
  { key: 'traffic_sign_recognition', label: 'Skiltegenkendelse', scope: 'variant' },
  { key: 'parking_sensors', label: 'Parkeringssensorer', scope: 'variant' },
  { key: 'rear_camera', label: 'Bakkamera', scope: 'variant' },
  { key: 'camera_360', label: '360° kamera', scope: 'variant' },
  { key: 'electric_tailgate', label: 'Elektrisk bagklap', scope: 'variant' },
  { key: 'keyless_entry', label: 'Keyless entry', scope: 'variant' },
  { key: 'digital_key', label: 'Digital nøgle', scope: 'variant' },
  { key: 'carplay_android_auto', label: 'Apple CarPlay & Android Auto', scope: 'variant' },
  { key: 'wireless_charging', label: 'Trådløs mobilopladning', scope: 'variant' },
  { key: 'navigation', label: 'Navigation', scope: 'variant' },
  { key: 'ota_opdateringer', label: 'OTA-opdateringer', scope: 'specs' },
  { key: 'head_up_display', label: 'Head-up display', scope: 'variant' },
  
  { key: 'heated_front_seats', label: 'Sædevarme foran', scope: 'variant' },
  { key: 'heated_rear_seats', label: 'Sædevarme bag', scope: 'variant' },
  { key: 'heated_steering_wheel', label: 'Ratvarme', scope: 'variant' },
  { key: 'ventilated_front_seats', label: 'Ventilerede forsæder', scope: 'variant' },
  { key: 'v2l', label: 'Vehicle-to-Load (V2L)', scope: 'specs', evOnly: true },
];

/** Sæt med alle equipment-keys — bruges til at ekskludere fra MissingFieldsBox. */
export const EQUIPMENT_FIELD_KEYS = new Set(EQUIPMENT_FIELDS.map(f => f.key));

export function getRelevantEquipment(powertrainType: string | null | undefined): EquipmentFieldDef[] {
  const isEV = powertrainType === 'EV';
  return EQUIPMENT_FIELDS.filter(f => (f.evOnly ? isEV : true));
}
